import { useTranslation } from "react-i18next";

import Faq from "../../components/ui/FAQ/Faq";
import Reviews from "../../components/ui/Reviews/Reviews";
import GoodPetsWP from "../../components/ui/GoodPetsWP/GoodPetsWP";
import MainSection from "../../components/ui/MainSection/MainSection";
import WhyRealGrass from "../../components/ui/WhyRealGrass/WhyRealGrass";
import VideoCarousel from "../../components/ui/VideoCarousel/VideoCarousel";
import HomeSecondSection from "../../components/ui/HomeSecondSection/HomeSecondSection";

import styles from "./homePage.module.scss";

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.homePage}>
      {/* The hero carousel duplicates its slides, so its headlines are h2s and
          the page's single H1 repeats both slide headlines here.
          SEO specialist: replace with an approved homepage H1 if desired. */}
      <h1 className={styles.visuallyHidden}>
        Fresh Grass: {t("realCatGrass")} &amp; {t("realGrassDogPotty")}
      </h1>
      <MainSection />
      <HomeSecondSection />
      <VideoCarousel />
      <Reviews />
      <WhyRealGrass />
      <GoodPetsWP />
      <Faq />
    </div>
  );
};

export default HomePage;
